export default class PurchaseRequisitionParser {
    static parseData(dataFromAPI, templateDataToReturn) {
        templateDataToReturn = dataFromAPI
        return templateDataToReturn
    }
}
